import { render, staticRenderFns } from "./MyZs4.vue?vue&type=template&id=633d3834&scoped=true&"
import script from "./MyZs4.vue?vue&type=script&lang=js&"
export * from "./MyZs4.vue?vue&type=script&lang=js&"
import style0 from "./MyZs4.vue?vue&type=style&index=0&id=633d3834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d3834",
  null
  
)

export default component.exports